<div class="d-flex justify-content-center align-items-center" style="height: 100vh">
  <div class="text-center">
    <div class="spinner-border text-success me-3" style="width: 2.75rem; height: 2.75rem" role="status"></div>
    <h4 class="mt-3">Setting up secure session...</h4>
  </div>
</div>
